/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1SerieSerieidLangsIdMutationRequest,
  PutApiV1SerieSerieidLangsIdMutationResponse,
  PutApiV1SerieSerieidLangsIdPathParams,
  PutApiV1SerieSerieidLangsId400,
  PutApiV1SerieSerieidLangsId401,
  PutApiV1SerieSerieidLangsId404,
  PutApiV1SerieSerieidLangsId500,
} from "../../types/serieIdiomasController/PutApiV1SerieSerieidLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1SerieSerieidLangsId } from "../../clients/serieIdiomasController/putApiV1SerieSerieidLangsId.ts";

export const putApiV1SerieSerieidLangsIdMutationKey = () =>
  [{ url: "/api/v1/serie/:serieId/langs/:id" }] as const;

export type PutApiV1SerieSerieidLangsIdMutationKey = ReturnType<
  typeof putApiV1SerieSerieidLangsIdMutationKey
>;

export function putApiV1SerieSerieidLangsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1SerieSerieidLangsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1SerieSerieidLangsIdMutationKey();
  return mutationOptions<
    PutApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieSerieidLangsId400
      | PutApiV1SerieSerieidLangsId401
      | PutApiV1SerieSerieidLangsId404
      | PutApiV1SerieSerieidLangsId500
    >,
    {
      serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: PutApiV1SerieSerieidLangsIdPathParams["id"];
      data?: PutApiV1SerieSerieidLangsIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ serieId, id, data }) => {
      return putApiV1SerieSerieidLangsId(serieId, id, data, config);
    },
  });
}

/**
 * @description Atualiza os textos de uma tradução (idioma) da série. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/:id}
 */
export function usePutApiV1SerieSerieidLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1SerieSerieidLangsIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1SerieSerieidLangsId400
        | PutApiV1SerieSerieidLangsId401
        | PutApiV1SerieSerieidLangsId404
        | PutApiV1SerieSerieidLangsId500
      >,
      {
        serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"];
        id: PutApiV1SerieSerieidLangsIdPathParams["id"];
        data?: PutApiV1SerieSerieidLangsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1SerieSerieidLangsIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1SerieSerieidLangsIdMutationKey();

  const baseOptions = putApiV1SerieSerieidLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieSerieidLangsId400
      | PutApiV1SerieSerieidLangsId401
      | PutApiV1SerieSerieidLangsId404
      | PutApiV1SerieSerieidLangsId500
    >,
    {
      serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: PutApiV1SerieSerieidLangsIdPathParams["id"];
      data?: PutApiV1SerieSerieidLangsIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieSerieidLangsId400
      | PutApiV1SerieSerieidLangsId401
      | PutApiV1SerieSerieidLangsId404
      | PutApiV1SerieSerieidLangsId500
    >,
    {
      serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: PutApiV1SerieSerieidLangsIdPathParams["id"];
      data?: PutApiV1SerieSerieidLangsIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1SerieSerieidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieSerieidLangsId400
      | PutApiV1SerieSerieidLangsId401
      | PutApiV1SerieSerieidLangsId404
      | PutApiV1SerieSerieidLangsId500
    >,
    {
      serieId: PutApiV1SerieSerieidLangsIdPathParams["serieId"];
      id: PutApiV1SerieSerieidLangsIdPathParams["id"];
      data?: PutApiV1SerieSerieidLangsIdMutationRequest;
    },
    TContext
  >;
}
